import {
  Box,
  Button,
  Heading,
  Input,
  Text,
  useToast,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { resetPasswordByToken } from "../api";

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const toast = useToast();

  const handleSubmit = async () => {
    if (!token) {
      toast({
        title: "유효하지 않은 링크입니다.",
        description: "비밀번호 찾기를 다시 진행해주세요.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    if (newPassword.length < 8 || newPassword.length > 64) {
      toast({
        title: "비밀번호는 8자 이상 64자 이하로 설정해주세요.",
        status: "warning",
        duration: 2500,
        isClosable: true,
      });
      return;
    }
    if (newPassword !== confirm) {
      toast({
        title: "비밀번호가 일치하지 않습니다.",
        status: "warning",
        duration: 2500,
        isClosable: true,
      });
      return;
    }

    setLoading(true);
    try {
      await resetPasswordByToken(token, newPassword);
      toast({
        title: "비밀번호가 변경되었습니다.",
        description: "새 비밀번호로 로그인해주세요.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      navigate("/login");
    } catch (e) {
      const msg =
        e?.response?.data?.error?.message ||
        "링크가 만료되었거나 유효하지 않습니다. 비밀번호 찾기를 다시 진행해주세요.";
      toast({
        title: "변경 실패",
        description: msg,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      minH="100vh"
      bgGradient="linear(to-b, white, blue.50)"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Box
        w="480px"
        bg="white"
        p="40px"
        borderRadius="20px"
        boxShadow="lg"
      >
        <Heading fontFamily="Pretendard" fontSize="24px" mb="8px">
          새 비밀번호 설정
        </Heading>

        {!token ? (
          <Text mt="24px" color="red.500" fontSize="14px">
            유효하지 않은 링크입니다. 비밀번호 찾기를 다시 진행해주세요.
          </Text>
        ) : (
          <VStack spacing="4" align="stretch" mt="32px">
            <Text fontSize="14px" color="gray.600">
              새 비밀번호를 입력해주세요. (8자 이상 64자 이하)
            </Text>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <Input
                h="46px"
                mb="12px"
                placeholder="새 비밀번호"
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <Input
                h="46px"
                mb="16px"
                placeholder="새 비밀번호 확인"
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
              />
              <Button
                type="submit"
                isLoading={loading}
                w="100%"
                h="46px"
                bg="#0054C0"
                color="white"
                fontFamily="Pretendard"
                fontSize="16px"
                _hover={{ bg: "#0043A0" }}
              >
                비밀번호 변경
              </Button>
            </form>
          </VStack>
        )}
      </Box>
    </Box>
  );
}
